import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare device detail route redirects to the default Overview tab.
export const Route = createFileRoute('/_app/devices/$deviceId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/devices/$deviceId/overview',
      params: { deviceId: params.deviceId },
    });
  },
});
